// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/Svg/drop-down-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --dashbord-bannder-height: 97px;
    --border-color1: #3E66B1;
}

.dashbord-header-start-section {
    min-height: var(--dashbord-bannder-height);
    background: var(--bg-dark-blue) 0% 0% no-repeat padding-box;
    color: var(--neutral-color1);
}

.dashbord-header-banner-content-section {
    min-height: var(--dashbord-bannder-height);
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 3px;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.dashbord-header-banner-content-section>h3 {
    font: normal normal 300 28px/34px Lato;
    letter-spacing: 0.28px;
    margin: 0;
}

.dashbord-header-banner-content-section>h5 {
    font: normal normal 300 16px/19px Lato;
    letter-spacing: 0.16px;
    color: #CCCCCC;
    margin: 0;
}

.admin-dashbord-header-banner-content-section>h3{
    color: var(--indicators-yellow);
}

.dashbord-header-calendar-form-group-section{
    display: grid;
    grid-template-columns: 1fr 7fr;
}
.dashbord-header-calendar-form-group-section .calendar-form-group-item-section{
    min-height: 56px;
    background: var(--bg-blue) 0% 0% no-repeat padding-box;
}

.dashbord-header-calendar-form-group-section .calendar-form-group-item-section:first-child{
    padding-left: var(--padding-left);
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.calendar-form-group-item-today{
    height: 100%;
    display: grid;
    align-items: center;
}
.calendar-form-group-item-section .calendar-form-group-item-btn-group-section{
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 100%;
}
.calendar-form-group-item-section .calendar-form-group-item-btn-group-section .calendar-form-group-item-btn{
    padding: 0 10px;
    height: 100%;
    display: flex;
    align-items: center;
}
.calendar-form-group-item-section .calendar-form-group-item-today, 
.calendar-form-group-item-btn-group-section .calendar-form-group-item-btn{
    cursor: pointer;
}
.calendar-form-group-item-section .calendar-form-group-item-btn-group-section .calendar-form-group-item-btn:hover svg path{
    stroke: var(--call-to-action1);
}
.calendar-form-group-item-section .calendar-form-group-item-date-changer-section:hover .calendar-form-group-item-iocn svg path{
    fill: var(--call-to-action1);
}
.calendar-form-group-item-section .calendar-form-group-item-today:hover {
    color: var(--call-to-action1);
}

.dashbord-header-calendar-form-group-section .calendar-form-group-item-section:last-child{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.calendar-form-group-item-section .calendar-form-group-item-date-changer-section{
    display: flex;
    height: 100%;
    align-items: center;
    border-right: 1px solid var(--border-color1);
    max-width: 200px;
    justify-content: space-around;
}

.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
}
.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker .react-date-picker{
    width: 100%;
    height: 100%;
}

.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker .react-date-picker .react-date-picker__wrapper{
    opacity: 0;
}

.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker .react-date-picker .react-date-picker__wrapper .react-date-picker__calendar-button{
    position: absolute;
    width: 100%;
    height: 100%;
}

.calendar-form-group-item-date-changer-content{
    font: normal normal 12px/15px Lato;
    letter-spacing: 0px;
    color: #E6E6E6;
    height: 100%;
    display: grid;
    align-items: flex-start;
    padding: 0 10px;
    cursor: default;
}
.calendar-form-group-item-date-changer-content h4{
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0px;
    color: #FFFFFF;
    text-align: start;
}
.calendar-form-group-item-date-changer-content h6{
    display: grid;
    height: 100%;
    align-items: flex-end;
}
.calendar-form-group-item-iocn{
    height: 100%;
    padding: 0 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.calendar-form-group-item-date-changer-section .calendar-form-group-item-date-changer-content{
    cursor: default;
}
.custom-transparent-form-group{
    border-left: 1px solid var(--border-color1);
}
.custom-transparent-form-group select{
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) right var(--padding-left) center/12px 12px no-repeat !important;
    border-radius: 0;
    border: 0;
    color: var(--neutral-color1);
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0px;
}
.custom-transparent-form-group select option{
    color: var(--neutral-color7);
}
.custom-transparent-form-group select option:first-child{
    color: var(--neutral-color1);
    display: none;
}

/* Filter section */
.dashbord-header-filter-section{
    height: 56px;
    background: var(--neutral-color2) 0% 0% no-repeat padding-box;
    border: 1px solid var(--neutral-color4);
    padding: 0 var(--padding-left);
    padding-right: 0;
    display: flex;
    align-items: center;
    font: normal normal 20px/24px Lato;
    letter-spacing: 0.2px;
    color: var(--neutral-color6);
    justify-content: space-between;
    border-left: 0;
    border-right: 0;
}
.dashbord-header-filter-section .dashbord-header-filter-item-toggle-btn{
    height: 100%;
    padding: 0 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root {
        --dashbord-bannder-height: 80px;
        --border-color1: #3E66B1;
    }
    .dashbord-header-banner-content-section{
        align-items: start;
        padding: 0 var(--padding-left);
        text-align: left;
    }
    .dashbord-header-banner-content-section h3{
        font: normal normal 300 18px/22px Lato;
        letter-spacing: 0.18px;
    }
    .dashbord-header-banner-content-section h5{
        font: normal normal 300 14px/17px Lato;
        letter-spacing: 0.14px;
    }
    .calendar-form-group-item-section .calendar-form-group-item-date-changer-section{
        max-width: 100%;
        justify-content: space-between;
    }
    .dashbord-header-calendar-form-group-section{
        grid-template-columns: 1fr;
    }
    .dashbord-header-calendar-form-group-section .calendar-form-group-item-section:first-child{
        border-bottom: 1px solid var(--border-color1);
        justify-content: start;
    }
    .calendar-form-group-item-today{
        margin-right: 10px;
    }
    .calendar-form-group-item-date-changer-section{
        justify-content: space-between;
        border-left: 0;
    }
    .calendar-form-group-item-date-changer-content{
        padding-left: var(--padding-left);
    }
    .calendar-form-group-item-date-changer-content > h6{
        font: normal normal 12px/15px Lato;
    }
    .dashbord-header-filter-section{
        font: normal normal normal 16px/19px Lato;
        letter-spacing: 0.16px;
    }
    .dashbord-header-filter-section .dashbord-header-filter-item-toggle-btn{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/SupervisorDashbord.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;IAC1C,2DAA2D;IAC3D,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,sDAAsD;AAC1D;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,4CAA4C;IAC5C,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;AACA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,+HAA+H;IAC/H,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,uCAAuC;IACvC,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;IAC5B,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,6DAA6D;IAC7D,uCAAuC;IACvC,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,qBAAqB;IACrB,4BAA4B;IAC5B,8BAA8B;IAC9B,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA,wCAAwC;AACxC;IACI;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,kBAAkB;QAClB,8BAA8B;QAC9B,gBAAgB;IACpB;IACA;QACI,sCAAsC;QACtC,sBAAsB;IAC1B;IACA;QACI,sCAAsC;QACtC,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,8BAA8B;IAClC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,6CAA6C;QAC7C,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,8BAA8B;QAC9B,cAAc;IAClB;IACA;QACI,iCAAiC;IACrC;IACA;QACI,kCAAkC;IACtC;IACA;QACI,yCAAyC;QACzC,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[":root {\r\n    --dashbord-bannder-height: 97px;\r\n    --border-color1: #3E66B1;\r\n}\r\n\r\n.dashbord-header-start-section {\r\n    min-height: var(--dashbord-bannder-height);\r\n    background: var(--bg-dark-blue) 0% 0% no-repeat padding-box;\r\n    color: var(--neutral-color1);\r\n}\r\n\r\n.dashbord-header-banner-content-section {\r\n    min-height: var(--dashbord-bannder-height);\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 3px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.dashbord-header-banner-content-section>h3 {\r\n    font: normal normal 300 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    margin: 0;\r\n}\r\n\r\n.dashbord-header-banner-content-section>h5 {\r\n    font: normal normal 300 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: #CCCCCC;\r\n    margin: 0;\r\n}\r\n\r\n.admin-dashbord-header-banner-content-section>h3{\r\n    color: var(--indicators-yellow);\r\n}\r\n\r\n.dashbord-header-calendar-form-group-section{\r\n    display: grid;\r\n    grid-template-columns: 1fr 7fr;\r\n}\r\n.dashbord-header-calendar-form-group-section .calendar-form-group-item-section{\r\n    min-height: 56px;\r\n    background: var(--bg-blue) 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.dashbord-header-calendar-form-group-section .calendar-form-group-item-section:first-child{\r\n    padding-left: var(--padding-left);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.calendar-form-group-item-today{\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-btn-group-section{\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    height: 100%;\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-btn-group-section .calendar-form-group-item-btn{\r\n    padding: 0 10px;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-today, \r\n.calendar-form-group-item-btn-group-section .calendar-form-group-item-btn{\r\n    cursor: pointer;\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-btn-group-section .calendar-form-group-item-btn:hover svg path{\r\n    stroke: var(--call-to-action1);\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-date-changer-section:hover .calendar-form-group-item-iocn svg path{\r\n    fill: var(--call-to-action1);\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-today:hover {\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.dashbord-header-calendar-form-group-section .calendar-form-group-item-section:last-child{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-date-changer-section{\r\n    display: flex;\r\n    height: 100%;\r\n    align-items: center;\r\n    border-right: 1px solid var(--border-color1);\r\n    max-width: 200px;\r\n    justify-content: space-around;\r\n}\r\n\r\n.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n}\r\n.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker .react-date-picker{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker .react-date-picker .react-date-picker__wrapper{\r\n    opacity: 0;\r\n}\r\n\r\n.calendar-form-group-item-section .calendar-form-group-item-date-changer-section .calendar-form-group-item-datepicker .react-date-picker .react-date-picker__wrapper .react-date-picker__calendar-button{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.calendar-form-group-item-date-changer-content{\r\n    font: normal normal 12px/15px Lato;\r\n    letter-spacing: 0px;\r\n    color: #E6E6E6;\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: flex-start;\r\n    padding: 0 10px;\r\n    cursor: default;\r\n}\r\n.calendar-form-group-item-date-changer-content h4{\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0px;\r\n    color: #FFFFFF;\r\n    text-align: start;\r\n}\r\n.calendar-form-group-item-date-changer-content h6{\r\n    display: grid;\r\n    height: 100%;\r\n    align-items: flex-end;\r\n}\r\n.calendar-form-group-item-iocn{\r\n    height: 100%;\r\n    padding: 0 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n.calendar-form-group-item-date-changer-section .calendar-form-group-item-date-changer-content{\r\n    cursor: default;\r\n}\r\n.custom-transparent-form-group{\r\n    border-left: 1px solid var(--border-color1);\r\n}\r\n.custom-transparent-form-group select{\r\n    background: transparent url(\"../Images/Svg/drop-down-icon.svg\") right var(--padding-left) center/12px 12px no-repeat !important;\r\n    border-radius: 0;\r\n    border: 0;\r\n    color: var(--neutral-color1);\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0px;\r\n}\r\n.custom-transparent-form-group select option{\r\n    color: var(--neutral-color7);\r\n}\r\n.custom-transparent-form-group select option:first-child{\r\n    color: var(--neutral-color1);\r\n    display: none;\r\n}\r\n\r\n/* Filter section */\r\n.dashbord-header-filter-section{\r\n    height: 56px;\r\n    background: var(--neutral-color2) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--neutral-color4);\r\n    padding: 0 var(--padding-left);\r\n    padding-right: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    font: normal normal 20px/24px Lato;\r\n    letter-spacing: 0.2px;\r\n    color: var(--neutral-color6);\r\n    justify-content: space-between;\r\n    border-left: 0;\r\n    border-right: 0;\r\n}\r\n.dashbord-header-filter-section .dashbord-header-filter-item-toggle-btn{\r\n    height: 100%;\r\n    padding: 0 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --dashbord-bannder-height: 80px;\r\n        --border-color1: #3E66B1;\r\n    }\r\n    .dashbord-header-banner-content-section{\r\n        align-items: start;\r\n        padding: 0 var(--padding-left);\r\n        text-align: left;\r\n    }\r\n    .dashbord-header-banner-content-section h3{\r\n        font: normal normal 300 18px/22px Lato;\r\n        letter-spacing: 0.18px;\r\n    }\r\n    .dashbord-header-banner-content-section h5{\r\n        font: normal normal 300 14px/17px Lato;\r\n        letter-spacing: 0.14px;\r\n    }\r\n    .calendar-form-group-item-section .calendar-form-group-item-date-changer-section{\r\n        max-width: 100%;\r\n        justify-content: space-between;\r\n    }\r\n    .dashbord-header-calendar-form-group-section{\r\n        grid-template-columns: 1fr;\r\n    }\r\n    .dashbord-header-calendar-form-group-section .calendar-form-group-item-section:first-child{\r\n        border-bottom: 1px solid var(--border-color1);\r\n        justify-content: start;\r\n    }\r\n    .calendar-form-group-item-today{\r\n        margin-right: 10px;\r\n    }\r\n    .calendar-form-group-item-date-changer-section{\r\n        justify-content: space-between;\r\n        border-left: 0;\r\n    }\r\n    .calendar-form-group-item-date-changer-content{\r\n        padding-left: var(--padding-left);\r\n    }\r\n    .calendar-form-group-item-date-changer-content > h6{\r\n        font: normal normal 12px/15px Lato;\r\n    }\r\n    .dashbord-header-filter-section{\r\n        font: normal normal normal 16px/19px Lato;\r\n        letter-spacing: 0.16px;\r\n    }\r\n    .dashbord-header-filter-section .dashbord-header-filter-item-toggle-btn{\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
